import React from "react";
import { Button } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const OutlinedButtonMedium = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"Outlined Medium button"}
        value={"<Button variant={'outlined'}>Medium</Button>"}
      >
        <Button variant={"outlined"}>Medium</Button>
      </PreviewAndEditor>
    </>
  );
};

export default OutlinedButtonMedium;
